<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/hammer-sickle.svg" width="300px">
    <HelloWorld msg="Addio Mundo Immundo"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }
}
</script>
